import React, {useEffect, useState} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {Howl} from 'howler';
import song1 from '../../assets/music/1.mp3';
import song2 from '../../assets/music/2.mp3';
import song3 from '../../assets/music/3.mp3';
import {selectIsPlaying, selectSongs} from '../../redux/music/music.selector';
import {resetTrigger} from '../../redux/music/music.actions';


const AudioPlayer = () => {
	const [currentTrack, setCurrentTrack] = useState(0); // Current song index
	const [sound, setSound] = useState(null); // Holds the Howl instance
	const isPlaying = useSelector(selectIsPlaying);
	const songs = useSelector(selectSongs);
	const dispatch = useDispatch();

	// 🎯 1️⃣ Handles what happens when a song ends
	const handleSongEnd = index => {
		const nextIndex = (index + 1) % songs.length; 
		setCurrentTrack(nextIndex);
		playTrack(nextIndex); // Play the next track
	};

	// 🎵 2️⃣ Function to play a track by index
	const playTrack = index => {
		if (sound) {
			sound.stop(); // Stop the previous track
			sound.unload(); // Clean up memory
		}

		const newSound = new Howl({
			src: [songs[index]],
			format: ["mp3"],
			html5: true,
			onend: () => handleSongEnd(index), // Handle end of track here
		});

		newSound.play();
		setSound(newSound);
	};

	useEffect(() => {
		if (isPlaying) {
			playTrack(currentTrack);
		} else if (sound) {
			  sound.stop();
		}
	}, [isPlaying]);

	return <div />;
};

export default AudioPlayer;
